/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/no-unstable-nested-components */

import {
  NavigationContainer,
  getStateFromPath as defaultGetStateFromPath,
  useIsFocused,
  useNavigationContainerRef,
} from '@react-navigation/native';
import {
  Image,
  Platform,
  SafeAreaView,
  ScrollView,
  View,
  Text,
  TouchableWithoutFeedback,
} from 'react-native';
import LottieView from 'react-native-web-lottie';
// import { SafeAreaView, StatusBar } from "react-native";
import {
  OnboardingScreenStack,
  OnboardingWalkthroughStack,
  Screen,
  ScreenName,
  ScreenStack,
  UnauthenticatedScreens,
} from './StackConstants';
import {clubsLinkingScreens} from '@/Screens/Clubs/clubsLinking';
import {
  extractClubInviteCode,
  shouldDeferClubInviteNavigation,
} from '@/Screens/Clubs/clubInviteRedirect';
// import {ApplicationStackParamList} from '../../@types/navigation';
import CCColors from '@/Utils/CCColors';
import CCText from '../Atoms/CCText';
import {AppStyles} from '../styles';
// import Header from "../components/Header";
// import { Platform } from "react-native";
import React, {useEffect} from 'react';
// import SignIn from "../components/SignIn";
import {
  capitalizeFirstLetter,
  handleLogout,
  removeLocalStorage,
  setLocalStorage,
} from '../Utils/CommonUtils';

import {createStackNavigator} from '@react-navigation/stack';
import {createDrawerNavigator} from '@react-navigation/drawer';
import {useFlipper} from '@react-navigation/devtools';
import Spacer from '@/Atoms/Spacer';
import Box from '@/Atoms/Box';
import {
  vs,
  isPhone,
  WINDOW_WIDTH,
  WINDOW_HEIGHT,
  FontSizes,
} from '@/Utils/Dimensions';

import {useState} from 'react';
import {useLoginState} from '@/Hooks/LoginApi/loginApi';
import {isPostalCodeRequired} from '@/Utils/PostalCode';
import Login from '../Screens/Login';
import WaitList from '../Screens/WaitList';

import Ionicons from 'react-native-vector-icons/Ionicons';
import MainMenu from '@/Atoms/MainMenu';
import Header from '@/Atoms/Header';
import useIsMobile from '@/Hooks/useIsMobile';
import useLoggedInUserStore from '@/Store/loggedInUserstore';
import CCLoader from '@/Atoms/CCLoader';
import {GA4_TRACKING_ID} from '@/Utils/Constants';
import {loadExternalScripts} from './LoadExternalScripts';
import OnboardingWalkthrough from '@/Screens/OnboardingWalkthrough';
import ENV from '../../environment';
import {useMediaQuery} from '@/Hooks/useMediaQuery/useMediaQuery';
import useGetUserActivePlanApi from '@/Hooks/UserActivePlanApi/useGetUserActivePlan';
import {useUserPlanStore} from '@/Store/userPlanStore';
import CCHome from '@/Screens/CCHome';
import ConditionalRender from '@/Atoms/ConditionalRender';
import SubscriptionModal from '@/Screens/Subscription/components/Modals';
import AlertModal from '@/Components/AlertModal';
import SentryWrapper from '@/SentryWrapper';
import CaissaChatbot from '@/Components/CaissaChatbot';
import PostMessageHandler from './Handlers/PostMessageHandler';
import {SocketProvider} from '@/Providers/SocketProvider';
import {getLocalStorage} from '@/Utils/CommonUtils';
import ChallengeComponent from '@/Components/ChallengeComponent';
import FunChallengesGlobalListener from '@/Components/FunChallengesGlobalListener';
import UserAssistance from '@/Components/UserAssistance';
import Books from '@/Screens/Books';
import useGamePlayState from '@/Store/GamePlayStore';
import loggerInstance from '@/Utils/logger';
import ChatbotWithNavigationControl from '@/Components/CaissaChatbot/ChatbotWithNavigationControl';
import SwitchToAppModal from '@/Atoms/Header/SwitchToAppModal';
import CCHomeDownloadScreen from '@/Screens/CCHomeDownloadScreen';
import PincodeModal from '@/Screens/Dashboard/component/PincodeModal';
import {ToastProvider} from '@/toast/ToastProvider';

// import ENV from 'environment';
// import useSignInModalStore from "../components/SignIn/store";
// import { useTheme } from "../hooks";
// import withAuth from "./withAuth";

// const Stack = createStackNavigator<any>();

const ApplicationNavigator = () => {
  // const {Layout, darkMode, NavigationTheme} = useTheme();
  // const {colors} = NavigationTheme;
  // const openSideModal = useSignInModalStore(state => state.isOpen);
  const [showHome, setShowHome] = useState<boolean>(true);
  const [verificationError, setVerificationError] = useState<any>(null);

  const evaluateRedirect = async () => {
    const isEvaluate = await getLocalStorage('isEvaluate');
    if (isEvaluate) {
      setIsEvaluateUser(true);
      setIsAppReady(true);
    } else {
      setIsEvaluateUser(false);
      setIsAppReady(true);
    }
  };

  const gameplayStore = useGamePlayState();

  const logoutForAToken = async () => {
    const customToken =
      'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbl90eXBlIjoiYWNjZXNzIiwiZXhwIjoxNzQ5NTU0OTc4LCJpYXQiOjE3NDE3Nzg5NzgsImp0aSI6ImNiNzUyN2I3YzBlNTQ5ZjhiNDgyNTMxMTBjMmNjMTRiIiwidXNlcl9pZCI6NDU3NTUsInVzZXJfa2V5IjoiYmRhNzlmYTktMmU4MS00YTg3LTlmNWEtYTY2ZmMzZjk3NzU5In0.nzurlIv7RMN25sJ_CpwCe7XxtXLpGphw_U5WFAt6cW8';
    const token = await getLocalStorage('access_token');
    if (token === customToken) {
      handleLogout();
    }
  };

  useEffect(() => {
    if (!__DEV__) {
      loadExternalScripts?.();
    }
    evaluateRedirect();
    logoutForAToken();
    //   setLocalStorage(
    //     'access_token',
    //   "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbl90eXBlIjoiYWNjZXNzIiwiZXhwIjoxNzc2MTY2MDMyLCJpYXQiOjE3NjgzOTAwMzIsImp0aSI6ImI3MmM5YTA2ZDdhMjRjMTk4NzM3YTFlYzk3ZjUxODg5IiwidXNlcl9pZCI6Mzk3NjUsInVzZXJfa2V5IjoiNGNmYWNjYjMtMDU1OC00OTUxLTlkYjktNjZjMDgwNWFlZGY2In0.FcVlTdZShXKEHXIJvYXEPSFfh3xkhvbbYvH1ZCo2dDw"
    //     // "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbl90eXBlIjoiYWNjZXNzIiwiZXhwIjoxNzc1OTk2NjU2LCJpYXQiOjE3NjgyMjA2NTYsImp0aSI6ImQ5ZTFmMzhiMjA4YzQ0NGNiNjVhMTBhMGJmMDQwNTFjIiwidXNlcl9pZCI6NjQ1MTEsInVzZXJfa2V5IjoiZjQ2NWE0MGItY2VjZS00ZTQzLTg4ZWItNzdjN2IxZjFhMDc3In0.jSZ008PWAbelF6xhJ6MyXQnCehhlIxMU8uJdoLEEtC0"
    //     // "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbl90eXBlIjoiYWNjZXNzIiwiZXhwIjoxNzc1ODU3MTE3LCJpYXQiOjE3NjgwODExMTcsImp0aSI6ImUzYTAwMWIyOGMwNTRmM2Y4NzJiMTY4MGQ5ZmQ3ZTE5IiwidXNlcl9pZCI6MTg3MjMsInVzZXJfa2V5IjoiZGM0YmUyZDEtNWJjZS00YTI3LWIzZmItOTZlOWNjNDE4NmI5In0.ttHyC0YrcThQMjnk3UBLlV6R8NlIO-Cw7ZdvsuyoZko"
    //   //  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbl90eXBlIjoiYWNjZXNzIiwiZXhwIjoxNzc1OTIyOTkwLCJpYXQiOjE3NjgxNDY5OTAsImp0aSI6IjYwZDBiODNhOGIxZjQyMTE5ZTM5NjY3YTRmY2ZmMjJhIiwidXNlcl9pZCI6MzMzLCJ1c2VyX2tleSI6IjRlYjdkZGU4LTFmNzMtNDk5Yi04Zjc3LTVjZmFiZDIxZDg5NyJ9.59G4v4sBNSwuteZV7wbFJMrk0VCYEuPLfHgRG2kRO4M"
    //     // "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbl90eXBlIjoiYWNjZXNzIiwiZXhwIjoxNzc1NDg1NTQ3LCJpYXQiOjE3Njc3MDk1NDcsImp0aSI6IjAyNGE1ODYwMzNmYzRlNTE4ODRmOGJhY2Y5MDBhYTJlIiwidXNlcl9pZCI6NDY5OCwidXNlcl9rZXkiOiI2OTdkMmEyYS02YmU1LTRkODYtYTQxOC04MTMyN2NjOTZhNjYifQ.0p2dNM-ez6pu39dAccmY46gNagF6-rNm8vBcXURzQOw"
    // );

    if (!ENV.DEBUG_ENABLED) {
      // console.log = () => {};
    }
    gameplayStore.setShowChallengeExpire(false);
    // getActivePlan();
  }, []);

  if (!__DEV__) {
    console.log = () => {};

    console.error = () => {};
  }
  const navigationRef = useNavigationContainerRef();
  const [pendingClubInviteCode, setPendingClubInviteCode] = useState<
    string | null
  >(() =>
    typeof window === 'undefined'
      ? null
      : extractClubInviteCode(window.location.href),
  );
  const deliveredClubInviteRef = React.useRef<string | null>(null);
  const isUserLoggedInRef = React.useRef(false);
  const [isNavigationReady, setIsNavigationReady] = useState(false);
  let prefix;
  useFlipper(navigationRef);

  if (Platform.OS === 'web') {
    // @ts-ignore

    prefix = `${window?.location?.protocol}//${window?.location?.hostname}${
      // @ts-ignore
      window?.location?.port ? ':' + window?.location?.port : ''
    }/`;
  } else {
    // TODO: change url here
    prefix = 'myapp://';
  }

  function transformScreens(screens: Screen[]): {[key: string]: string} {
    const result: {[key: string]: string} = {};

    screens.forEach(screen => {
      result[capitalizeFirstLetter(screen.Name)] = screen.Name;
    });

    return result;
  }

  // Define linking configuration
  const linking = {
    prefixes: [prefix],
    config: {
      screens: {
        ...transformScreens(ScreenStack),
        ...transformScreens(OnboardingScreenStack),
        ...transformScreens(UnauthenticatedScreens),
        ...clubsLinkingScreens,
        CsocNewPayment: 'csoc-new-payment',
        ManualSubstituteAssignment: 'ManualSubstituteAssignment',
        SubstituteFlowDashboard: 'SubstituteFlowDashboard',
        // Puzzle Royale share link: /FunChallengesLobby?mode=multiplayer&join=<code>.
        // The royale lobby is NOT its own route — it renders in the Fun
        // Challenges lobby's Multiplayer tab. Explicit path + parse so a cold
        // open lands there with the Multiplayer tab open + the join code
        // prefilled (BattleLobby reads route.params.mode / .join). Additive —
        // overrides only this screen's auto-mapped path.
        FunChallengesLobby: {
          path: 'FunChallengesLobby',
          parse: {
            mode: (m: string | undefined) =>
              m == null || m === '' ? undefined : String(m),
            join: (code: string | undefined) =>
              code == null || code === '' ? undefined : String(code),
            // Coach classroom auto-create handoff key (see classroomRoyaleHandoff).
            royaleAutoCreate: (k: string | undefined) =>
              k == null || k === '' ? undefined : String(k),
            // Student classroom "Join Puzzle Royale": auto-join without a click.
            autoJoin: (v: string | undefined) =>
              v == null || v === '' ? undefined : String(v),
            // Coach reopen: classroom context for rematch re-registration.
            crMeeting: (v: string | undefined) =>
              v == null || v === '' ? undefined : String(v),
            crOccurence: (v: string | undefined) =>
              v == null || v === '' ? undefined : String(v),
          },
        },
        // Web: e.g. /opening-report/3539 or /opening-report (use ?tournamentId=3539 on the screen as fallback)
        OpeningPerformanceReport: {
          path: 'opening-report/:tournamentId?',
          parse: {
            tournamentId: (id: string | undefined) => {
              if (id == null || id === '') {
                return undefined;
              }
              const n = parseInt(id, 10);
              return Number.isNaN(n) ? undefined : n;
            },
          },
        },
      },
    },
    getStateFromPath: (path: string, options: any) => {
      // InviteRedeem is absent only from the signed-out navigator. Defer the
      // deep link while signed out, but let React Navigation resolve it
      // normally for an already-authenticated cold open.
      if (
        shouldDeferClubInviteNavigation(path, isUserLoggedInRef.current)
      ) {
        return undefined;
      }
      return defaultGetStateFromPath(path, options);
    },
  };

  const {isMobileOrTab} = useMediaQuery();
  // const isMobile = useIsMobile();
  // const isMobile = false;

  const Drawer = createDrawerNavigator();
  const Stack = createStackNavigator();
  const setIsThirdPartyUser = useLoggedInUserStore(
    state => state.setIsThirdPartyUser,
  );

  const [reloadLoginState, setReloadLoginState] = useState<boolean>(false);
  // modalUtils.ts
  const MODAL_KEY = 'lastAppModalShownTime';
  const MODAL_TIMEOUT_MS = 2 * 60 * 60 * 1000; // 2 hours
  const DESKTOP_MODAL_TIMEOUT_MS = 4 * 60 * 60 * 1000;
  const shouldShowSwitchToAppModal = async () => {
    const lastShown = await getLocalStorage(MODAL_KEY);
    const now = Date.now();
    const timeOut = isMobileOrTab ? MODAL_TIMEOUT_MS : DESKTOP_MODAL_TIMEOUT_MS;
    // Show if never shown before or 2 hours have passed
    return !lastShown || now - Number(lastShown) > timeOut;
  };

  const markModalAsShown = async () => {
    const timestamp = Date.now().toString();
    await setLocalStorage(MODAL_KEY, timestamp);
  };

  const {data, loading, isUserLoggedIn, error} =
    useLoginState(reloadLoginState);
  isUserLoggedInRef.current = isUserLoggedIn;
  const userPlanStore = useUserPlanStore();
  const [userData, setUserData] = useState({});
  const [summaryData, setSummaryData] = useState({});
  const [streakDetails, setStreakDetails] = useState();
  const [streakCount, setStreakCount] = useState();
  const [isBeginnerPlayer, setIsBeginnerPlayer] = useState<Boolean>();
  const [accessToken, setAccessToken] = useState('');
  const [isEvaluateUser, setIsEvaluateUser] = useState(false);
  const [isDemoUser, setIsDemoUser] = useState(false);
  const [modifyMainMenu, setModifyMainMenu] = useState(false);
  const [isAppReady, setIsAppReady] = useState(false);
  const [latestBookName, setLatestBookName] = useState();
  const [latestBookId, setLatestBookId] = useState();
  const [changeClient, setChangeClient] = useState(false);
  const [urlTournamentId, setUrlTournamentId] = useState<string | null>(null);
  const [storedTournamentId, setStoredTournamentId] = useState<
    string | null | unknown
  >(() => {
    try {
      return new URLSearchParams(window?.location?.search).get('tournamentId');
    } catch (e) {
      return null;
    }
  });
  const [showAppModal, setShowAppModal] = useState(false);
  const [showPincodeModal, setShowPincodeModal] = useState(false);
  const [modalDismissed, setModalDismissed] = useState(false);
  const [pincode, setPincode] = useState('');
  useEffect(() => {
    const unsubscribe = navigationRef?.addListener?.('state', async () => {
      const currentRoute = navigationRef.getCurrentRoute();
      console.log(currentRoute, 'currentRoute1');
      const shouldShow = await shouldShowSwitchToAppModal();
      if (shouldShow && isMobileOrTab) {
        setShowAppModal(true);
        await markModalAsShown();
      } else if (
        shouldShow &&
        !isMobileOrTab &&
        currentRoute?.name === 'home'
      ) {
        setShowAppModal(true);
        await markModalAsShown();
      }
    });
    return unsubscribe;
  }, [navigationRef]);
  const [authComplete, setAuthComplete] = useState(true);
  const handleUserVerified = async (data: any) => {
    await setLocalStorage('refresh_token', data?.refresh_token, true);
    await setLocalStorage('access_token', data?.access_token, true);
    await setLocalStorage('userkey', data?.user_key, true);
    setUserData(data);
    window.location.reload();
    console.log('User successfully verified:', data);
  };
  const handleVerificationError = (error: any) => {
    setVerificationError(error);
    console.error('Verification error:', error);
  };

  useEffect(() => {
    if (data?.data?.user) {
      setIsAppReady(false);
      evaluateRedirect();
    }
    setStreakDetails?.(data?.data?.streak_details);
    setStreakCount?.(data?.data?.streak_details_summary);
    setSummaryData(data?.data);
    setUserData(data?.data?.user);
  }, [data]);
  useEffect(() => {
    const onRefreshKey = async () => {
      const userKey = await getLocalStorage('user_key');
      if (userKey) {
        setModifyMainMenu(true);
      }
    };
    onRefreshKey();
  }, []);
  useEffect(() => {
    // Ask for a PIN/ZIP code only for users whose country actually has one.
    // Countries with no postal code system (e.g. UAE) are skipped; every other
    // country (India, US, UK, ...) is prompted when the code is missing.
    if (
      isPostalCodeRequired(data?.data?.user) &&
      (data?.data?.user?.pincode === null ||
        data?.data?.user?.pincode === '') &&
      !modalDismissed
    ) {
      setShowPincodeModal(true);
      console.log(showPincodeModal, 'showPincodeModal....');
    }
  }, [data?.data?.user]);
  useEffect(() => {
    const fetchTournamentId = async () => {
      const id = await getLocalStorage('tournamentId');
      if (id) {
        setStoredTournamentId(id);
      }
    };

    fetchTournamentId();
  }, [isEvaluateUser]);

  useEffect(() => {
    if (userData?.player_type === 1) {
      setIsBeginnerPlayer(true);
    } else {
      setIsBeginnerPlayer(false);
    }
  }, [userData]);

  // useEffect(() => {
  //   if (isUserLoggedIn) {
  //     setAuthorizationToken();
  //   }
  // }, [isUserLoggedIn]);

  const setAuthorizationToken = async () => {
    const token = await getLocalStorage('access_token');
    if (token) {
      setAccessToken(`Bearer ${token}`);
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const referral_code = params.get('ccpplearn');
    if (referral_code) {
      const storeReferralCode = async () => {
        await setLocalStorage('referral_code', referral_code);
      };
      storeReferralCode();
    }
  }, []);

  useEffect(() => {
    if (isUserLoggedIn) {
      setAuthorizationToken();
    }
  }, [isUserLoggedIn]);

  useEffect(() => {
    if (
      !isUserLoggedIn ||
      !isNavigationReady ||
      !pendingClubInviteCode ||
      deliveredClubInviteRef.current === pendingClubInviteCode
    ) {
      return;
    }

    // Login and authenticated routes swap in the same render. Wait until the
    // navigation container and authenticated drawer are ready before replaying
    // the invite route.
    const timeout = setTimeout(() => {
      if (!navigationRef.isReady()) {
        return;
      }

      const currentRoute = navigationRef.getCurrentRoute();
      if (
        currentRoute?.name === 'InviteRedeem' &&
        (currentRoute?.params as any)?.code === pendingClubInviteCode
      ) {
        deliveredClubInviteRef.current = pendingClubInviteCode;
        setPendingClubInviteCode(null);
        return;
      }

      deliveredClubInviteRef.current = pendingClubInviteCode;
      navigationRef.navigate('InviteRedeem', {
        code: pendingClubInviteCode,
      });
      setPendingClubInviteCode(null);
    }, 0);

    return () => clearTimeout(timeout);
  }, [
    isNavigationReady,
    isUserLoggedIn,
    navigationRef,
    pendingClubInviteCode,
  ]);

  window.addEventListener('storage', event => {
    if (event.key === 'logoutEvent' || event.key === 'loginEvent') {
      // Perform logout actions in this tab
      window.location.reload(true);
    }
  });
  useEffect(() => {
    const unsubscribe = navigationRef?.addListener?.('state', () => {
      const currentRoute = navigationRef.getCurrentRoute();

      // if (currentRoute?.name !== ScreenName.AssessmentReport) {
      //   setModifyMainMenu(false); // Reset only when leaving AssessmentReport
      // }
    });
    return unsubscribe;
  }, [navigationRef]);
  // don't put any hooks after this
  if (loading || !isAppReady) {
    // return <Text>Loading...</Text>;
    return <CCLoader loading bgWhite />;
  }
  if (error) {
    return (
      <View
        style={{
          flex: 1,
          justifyContent: 'center',
          alignItems: 'center',
        }}>
        <Image
          resizeMode="contain"
          style={{width: vs(200), height: vs(100)}}
          source={require('@/Assets/Images/Svgs/cc-logo-light.svg')}
        />
        <Box
          justifyContent="center"
          alignItems="center"
          style={{paddingHorizontal: 10}}>
          <LottieView
            source={require('../Assets/Animation/error_boundary_animation.json')}
            style={{width: WINDOW_WIDTH / 2, height: WINDOW_HEIGHT / 2}}
            autoPlay
            loop
          />

          <CCText fontSize={FontSizes[20]}>{error}</CCText>
        </Box>

        <Spacer spacing={10} />
        <UserAssistance />
      </View>
    );
  }

  useLoggedInUserStore.setState({
    gems: data.data?.avatar?.gems,
    pointsToNextLevel:
      data.data?.avatar?.points_to_next_level + data.data?.avatar?.gems,
    level: data.data?.avatar?.level + 1,
    netScore: data.data?.user?.net_score,
    streakConfig: streakDetails,
    streakDetailsSummary: streakCount,
  });

  function onLoginStateChange() {
    setReloadLoginState(prev => !prev);
    // removeLocalStorage('current_path')

    // setIsUserLoggedIn(true)
  }

  function isUserOnboarded(data) {
    return data.data?.user?.learning_onboarding_status;
  }

  function isNewUser(data) {
    return !(
      data.data?.user?.seen_walkthroughs?.includes?.('learning') ||
      data.data?.user?.learning_onboarding_status == 3
    );
  }

  // if (isUserLoggedIn && isMobile) {
  //   return (
  //     <>
  //       <Image
  //         style={{
  //           width: 162,
  //           height: 32,
  //           margin: 24,
  //         }}
  //         source={require('@/Assets/Images/Svgs/cc-logo-light.svg')}
  //       />
  //       <Box
  //         style={{
  //           flex: 1,
  //           // flexDirection: 'row',
  //           justifyContent: 'center',
  //           alignItems: 'center',
  //           padding: 20,
  //           // height: '98vh',
  //         }}>
  //         <View style={{transform: [{perspective: 1000}]}}>
  //           <LottieView
  //             source={require('../Assets/Animation/under_construction.json')}
  //             // style={{width: WINDOW_WIDTH / 2, height: WINDOW_HEIGHT / 2}}
  //             autoPlay
  //             loop
  //           />
  //         </View>
  //         <CCText textAlign="center" style={{fontSize: 20}}>
  //           Please switch to a laptop or desktop for the best experience.
  //         </CCText>
  //       </Box>
  //     </>
  //   );
  // }
  // TODO: Both inline styles are not having any effect. The inner Box element is also not needed.
  // Verify.

  const username = userData?.user_id?.toString() || '';
  const originalInfo = console.info;
  // if (username && !console.info.isOverridden) {
  //   console.info = function (...args) {
  //     // Persist log to your Django server
  //     fetch('https://api.circlechess.com/client_logs/', {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'X-Username': username, // Custom header for username
  //       },
  //       body: JSON.stringify({log: args}),
  //     }).catch(err => originalInfo('Failed to send log to server', err));

  //     // Also log to the console
  //     if (ENV.DEBUG_ENABLED) {
  //       originalInfo.apply(console, args);
  //     }
  //   };
  //   console.info.isOverridden = true;
  // }

  // if (username && !console.info.isOverridden) {
  //   console.info = function (...args) {
  //     // Add to batch instead of immediate send
  //     loggerInstance.write(username, ...args);

  //     // Also log to console in debug mode
  //     if (ENV.DEBUG_ENABLED) {
  //       originalInfo.apply(console, args);
  //     }
  //   };
  //   console.info.isOverridden = true;
  // }
  // Check current path
  const currentPath = window.location.pathname;
  console.log('currentPath', currentPath);

  // If it's the download app route, render that component directly
  if (currentPath === '/downloadApp') {
    return <CCHomeDownloadScreen />;
  }
  const userScreens = () => {
    let userType = 'not-loggedin';

    if (!isUserLoggedIn) {
      if (!isUserOnboarded(data) && showHome) {
        userType = 'not-loggedin';
      }
    } else if (isUserLoggedIn) {
      if (isEvaluateUser) {
        userType = 'loggedin and evaluate user';
      } else if (!isUserOnboarded(data)) {
        userType = 'loggedin and not onboarded';
      } else if (isUserOnboarded(data) && isNewUser(data)) {
        userType = 'loggedin and onboarded but walkthrough is pending';
      } else if (
        isUserOnboarded(data) &&
        !isNewUser(data) &&
        isBeginnerPlayer
      ) {
        userType = 'loggedin and beginner player';
      } else if (isUserOnboarded(data) && !isNewUser(data) && modifyMainMenu) {
        userType = 'loggedin and coach view';
      } else {
        userType = 'loggedin';
      }
    }

    const allowedScreensForBeginners = [
      'dashboard',
      'playChess',
      'courses',
      'games',
      'chessAnalysis',
      'leaderboard',
      'resources',
      'positions',
      'VisualisationTrainer',
      'Rules-and-Rewards',
      'RequestAccess',
      'Settings',
      'ReportAnIssue',
      'subscription',
      'Classroom',
      'SupportTicket',
      'Inbox',
      'importgames',
      'Renewal',
      'CCTournaments',
      'OpeningPerformanceReport',
      'RenewalPuzzleChallenge',
      'CsocNewPayment',
      'Clubs',
      'ClubProfile',
      'ClubRoom',
      'ClubAdmin',
      'ClubStandings',
      'InviteRedeem',
      'FunChallengesLobby',
      'FunChallengeBattle',
      'PuzzleRoyaleBattle',
    ];

    const allowedScreensCoachview = ['assessmentReport', 'reports'];

    let filteredScreenStack = ScreenStack;

    if (isBeginnerPlayer) {
      filteredScreenStack = ScreenStack.filter(screen =>
        allowedScreensForBeginners.includes(screen.Name),
      );
    } else if (modifyMainMenu) {
      filteredScreenStack = ScreenStack.filter(screen =>
        allowedScreensCoachview.includes(screen.Name),
      );
    }

    if (
      userPlanStore?.planDetails?.user_subscription_details?.fields?.source ===
      'csoc'
    ) {
      filteredScreenStack = ScreenStack.filter(
        screen => screen.Name !== 'subscription',
      );
    }

    switch (userType) {
      case 'not-loggedin': {
        const isRenewalPath = ['/renewal', '/csoc-new-payment'].includes(
          currentPath?.toLowerCase(),
        );
        const isClubInvitePath = Boolean(
          extractClubInviteCode(window.location.href),
        );
        return (
          <Stack.Navigator
            screenOptions={{headerShown: false}}
            initialRouteName={
              isRenewalPath || isClubInvitePath ? 'Login' : 'home'
            }>
            <Stack.Screen name="home">
              {props => (
                <CCHome
                  {...props}
                  onLoginStateChange={onLoginStateChange}
                  setShowHome={setShowHome}
                />
              )}
            </Stack.Screen>
            <Stack.Screen name="Login">
              {props => (
                <Login
                  {...props}
                  onLoginStateChange={onLoginStateChange}
                  setUrlTournamentId={setUrlTournamentId}
                  isEvaluate={false}
                />
              )}
            </Stack.Screen>
            <Stack.Screen name="EvaluateLogin">
              {props => (
                <Login
                  {...props}
                  onLoginStateChange={onLoginStateChange}
                  setUrlTournamentId={setUrlTournamentId}
                  isEvaluate={true}
                />
              )}
            </Stack.Screen>
            <Stack.Screen name="Cc-admin-login">
              {props => (
                <Login
                  {...props}
                  onLoginStateChange={onLoginStateChange}
                  setUrlTournamentId={setUrlTournamentId}
                  isEvaluate={false}
                />
              )}
            </Stack.Screen>
          </Stack.Navigator>
        );
      }

      case 'loggedin and evaluate user':
        return (
          <Stack.Navigator screenOptions={{headerShown: false}}>
            <Stack.Screen
              name="resouces"
              initialParams={{
                tab: 'user_assignment',
                name: latestBookId,
                bookkey: latestBookName,
                tournamentId: urlTournamentId ?? storedTournamentId,
              }}>
              {props => (
                <Books
                  {...props}
                  dashboardData={{...data, data: {...data.data, user: userData}}}
                  setLatestBookId={setLatestBookId}
                  setLatestBookName={setLatestBookName}
                  setUserData={setUserData}
                />
              )}
            </Stack.Screen>
          </Stack.Navigator>
        );

      case 'loggedin and not onboarded':
        return (
          <Stack.Navigator screenOptions={{headerShown: false}}>
            {OnboardingScreenStack?.map(screen => (
              <Stack.Screen
                key={screen.id}
                name={capitalizeFirstLetter(screen.Name)}>
                {(props: any) => (
                  <Box style={{flex: 1}}>
                    <Box>
                      <screen.component
                        {...props}
                        onLoginStateChange={onLoginStateChange}
                        userData={data.data.user}
                        fullData={data.data}
                      />
                    </Box>
                  </Box>
                )}
              </Stack.Screen>
            ))}
          </Stack.Navigator>
        );

      case 'loggedin and onboarded but walkthrough is pending':
        return (
          <Stack.Navigator screenOptions={{headerShown: false}}>
            <Stack.Screen name="OnboardingWalkthrough">
              {props => (
                <OnboardingWalkthrough
                  {...props}
                  isBeginnerPlayer={isBeginnerPlayer}
                  onLoginStateChange={onLoginStateChange}
                />
              )}
            </Stack.Screen>
          </Stack.Navigator>
        );

      case 'loggedin and beginner player':
        return (
          <SocketProvider
            username={username}
            accessToken={accessToken}
            setChangeClient={setChangeClient}
            setAuthComplete={setAuthComplete}>
            <ToastProvider>
              {!isMobileOrTab ? (
                <Header
                  isMobile={isMobileOrTab}
                  userData={userData}
                  avatar={data.data.avatar}
                  navigationRef={navigationRef}
                  onLoginStateChange={onLoginStateChange}
                  summaryData={summaryData}
                />
              ) : (
                <></>
              )}
              <Drawer.Navigator
                backBehavior="history"
                screenOptions={{
                  drawerType: isMobileOrTab ? 'front' : 'permanent',
                  drawerStyle: isMobileOrTab
                    ? AppStyles.mobileMenu
                    : AppStyles.menu,
                  headerShown: isMobileOrTab,
                  sceneContainerStyle: {backgroundColor: CCColors.Background},
                  header: props =>
                    isMobileOrTab ? (
                      <Header
                        isMobile={isMobileOrTab}
                        userData={userData}
                        avatar={data.data.avatar}
                        navigationRef={navigationRef}
                        onLoginStateChange={onLoginStateChange}
                        showAppModal={showAppModal}
                        setShowAppModal={setShowAppModal}
                        summaryData={summaryData}
                      />
                    ) : null,
                }}
                drawerContent={props => {
                  const modifiedProps = {
                    ...props,
                    state: {
                      ...props.state,
                      routes: [props.state.routes[3]],
                      index: 3,
                    },
                  };
                  const currentRoute =
                    props.state.routes[props.state.index].name; // Get current active route name
                  console.log(props.state.routes, 'Current Route'); // Debugging log

                  return (
                    <>
                      <MainMenu
                        isMobile={isMobileOrTab}
                        {...(modifyMainMenu ? modifiedProps : props)}
                        userIsStaff={data?.data?.user?.is_staff}
                        id={data?.data?.assessment?.id}
                        openingGamePercentage={
                          data?.data?.assessment?.score?.opening
                        }
                        middleGamePercentage={
                          data?.data?.assessment?.score?.middlegame
                        }
                        endGamePercentage={
                          data?.data?.assessment?.score?.endgame
                        }
                        calculationDepthPercentage={
                          data?.data?.assessment?.score?.calculation_depth
                        }
                      />
                    </>
                  );
                }}>
                {filteredScreenStack.map(screen => {
                  const isChessAnalysisScreen = [
                    'chessAnalysis',
                    'leaderboard',
                    'positions',
                    'RenewalPuzzleChallenge',
                    'playChess',
                    'SaveOTBGames',
                    'resources',
                    'VisualisationTrainer',
                    'studyDetails',
                    'playChess',
                    'assessmentReport',
                    'Classroom',
                    'CCTournaments',
                    'FunChallengeBattle',
                    'PuzzleRoyaleBattle',
                    'ClubRoom',
                    'ClubProfile',
                  ].includes(screen.Name);

                  const Container = isChessAnalysisScreen ? View : ScrollView;
                  let formatedOptions =
                    isUserOnboarded(data) === 2
                      ? {
                          ...screen.menuOptions,
                          disabled: screen.menuOptions.preAnalysisDisabled,
                          unmountOnBlur: false,
                        }
                      : {...screen.menuOptions, disabled: false};

                  return (
                    <Drawer.Screen
                      key={screen.id}
                      name={capitalizeFirstLetter(screen.Name)}
                      options={formatedOptions}>
                      {(props: any) => (
                        <RenderOnFocus>
                          <Container
                            showsVerticalScrollIndicator={false}
                            showsHorizontalScrollIndicator={false}
                            // Ensure the ScrollView's content container fills the
                            // viewport height so short screens (whose root is
                            // flex:1) stretch instead of collapsing to content
                            // height and leaving a gap below.
                            contentContainerStyle={{minHeight: '100%'}}
                            style={{
                              height: '100%',
                              overflowY: [
                                'Inbox',
                                'SupportTicket',
                                'RequestAccess',
                              ].includes(screen.Name)
                                ? 'hidden'
                                : 'scroll',
                              overflowX: 'hidden',
                            }}>
                            <screen.component
                              {...props}
                              {...screen.props}
                              dashboardData={{...data.data, user: userData}}
                              data={data}
                              isUserLoggedIn={isUserLoggedIn}
                              isLoading={loading}
                              userData={userData}
                              setUserData={setUserData}
                              isBeginnerPlayer={isBeginnerPlayer}
                              changeClient={changeClient}
                              setChangeClient={setChangeClient}
                              authComplete={authComplete}
                            />
                          </Container>
                        </RenderOnFocus>
                      )}
                    </Drawer.Screen>
                  );
                })}
              </Drawer.Navigator>
              <ChatbotWithNavigationControl navigationRef={navigationRef} />
              <ChallengeComponent username={username} />
              <FunChallengesGlobalListener />
            </ToastProvider>
          </SocketProvider>
        );

      case 'loggedin and coach view':
        return (
          <SocketProvider
            username={username}
            accessToken={accessToken}
            setChangeClient={setChangeClient}
            setAuthComplete={setAuthComplete}>
            {!isMobileOrTab ? (
              <Header
                isMobile={isMobileOrTab}
                userData={userData}
                avatar={data?.data?.avatar}
                navigationRef={navigationRef}
                onLoginStateChange={onLoginStateChange}
                summaryData={summaryData}
                setModifyMainMenu={setModifyMainMenu}
                modifyMainMenu={modifyMainMenu}
              />
            ) : (
              <></>
            )}
            <Drawer.Navigator
              backBehavior="history"
              screenOptions={{
                drawerType: isMobileOrTab ? 'front' : 'permanent',
                drawerStyle: isMobileOrTab
                  ? AppStyles.mobileMenu
                  : AppStyles.menu,

                headerShown: isMobileOrTab,
                sceneContainerStyle: {
                  backgroundColor: CCColors.Background,
                },
                header: props => {
                  if (isMobileOrTab) {
                    return (
                      <Header
                        isMobile={isMobileOrTab}
                        userData={userData}
                        avatar={data?.data?.avatar}
                        navigationRef={navigationRef}
                        onLoginStateChange={onLoginStateChange}
                        summaryData={summaryData}
                        showAppModal={showAppModal}
                        setShowAppModal={setShowAppModal}
                      />
                    );
                  }
                },
              }}
              drawerContent={props => {
                return (
                  <>
                    <MainMenu
                      isMobile={isMobileOrTab}
                      {...props}
                      userIsStaff={data?.data?.user?.is_staff}
                      id={data?.data?.assessment?.id}
                      openingGamePercentage={
                        data?.data?.assessment?.score?.opening
                      }
                      middleGamePercentage={
                        data?.data?.assessment?.score?.middlegame
                      }
                      endGamePercentage={data?.data?.assessment?.score?.endgame}
                      calculationDepthPercentage={
                        data?.data?.assessment?.score?.calculation_depth
                      }
                      modifyMainMenu={modifyMainMenu}
                    />
                  </>
                );
              }}>
              {filteredScreenStack?.map(screen => {
                const isChessAnalysisScreen = [
                  'chessAnalysis',
                  'leaderboard',
                  'positions',
                  'RenewalPuzzleChallenge',
                  'playChess',
                  'SaveOTBGames',
                  'resources',
                  'VisualisationTrainer',
                  'studyDetails',
                  'playChess',
                  'assessmentReport',
                  'Classroom',
                  'CCTournaments',
                  'FunChallengeBattle',
                  'PuzzleRoyaleBattle',
                  'ClubRoom',
                  'ClubProfile',
                ]?.includes(screen.Name);
                console.log(screen.Name, 'screen.Name');
                const isSubscriptionOrCSOCTab =
                  screen.Name?.toLowerCase() === 'subscription' ||
                  screen.Name?.toLowerCase() === 'resources';

                const Container = isChessAnalysisScreen ? View : ScrollView;
                let formatedOptions =
                  isUserOnboarded(data) === 2
                    ? {
                        ...screen.menuOptions,
                        disabled: screen.menuOptions.preAnalysisDisabled,
                        unmountOnBlur: false,
                      }
                    : {...screen.menuOptions, disabled: false};
                if (
                  isSubscriptionOrCSOCTab &&
                  data?.data?.user?.source?.toLowerCase() === 'chessklub'
                ) {
                  setIsThirdPartyUser(true);
                  formatedOptions = {
                    // label: 'subscription',
                    hide: true,
                  };
                }
                if (!data.data.user.is_staff && screen?.menuOptions?.isStaff) {
                  formatedOptions = {
                    // label: 'subscription',
                    hide: true,
                  };
                }
                return (
                  <Drawer.Screen
                    key={screen.id}
                    name={capitalizeFirstLetter(screen.Name)}
                    options={formatedOptions}>
                    {(props: any) => (
                      <RenderOnFocus>
                        <Container
                          showsVerticalScrollIndicator={false}
                          showsHorizontalScrollIndicator={false}
                          contentContainerStyle={{minHeight: '100%'}}
                          style={{
                            height: '100%',
                            overflowY: 'scroll',
                            overflowX: 'hidden',
                          }}>
                          <screen.component
                            {...props}
                            {...screen.props}
                            dashboardData={data.data}
                            data={data}
                            isUserLoggedIn={isUserLoggedIn}
                            isLoading={loading}
                            userData={userData}
                            setUserData={setUserData}
                            isBeginnerPlayer={isBeginnerPlayer}
                            setStreakCount={setStreakCount}
                            setStreakDetails={setStreakDetails}
                            changeClient={changeClient}
                            setChangeClient={setChangeClient}
                            modifyMainMenu={modifyMainMenu}
                            authComplete={authComplete}
                          />
                        </Container>
                      </RenderOnFocus>
                    )}
                  </Drawer.Screen>
                );
              })}
            </Drawer.Navigator>
            <ChatbotWithNavigationControl navigationRef={navigationRef} />
            <ChallengeComponent username={username} />
            <FunChallengesGlobalListener />
          </SocketProvider>
        );

      case 'loggedin':
        return (
          <SocketProvider
            username={username}
            accessToken={accessToken}
            setChangeClient={setChangeClient}
            setAuthComplete={setAuthComplete}>
            <ToastProvider>
              {!isMobileOrTab ? (
                <Header
                  isMobile={isMobileOrTab}
                  userData={userData}
                  avatar={data.data.avatar}
                  navigationRef={navigationRef}
                  onLoginStateChange={onLoginStateChange}
                  summaryData={summaryData}
                  setModifyMainMenu={setModifyMainMenu}
                  modifyMainMenu={modifyMainMenu}
                  isEvaluateUser={isEvaluateUser}
                />
              ) : (
                <></>
              )}
              <Drawer.Navigator
                backBehavior="history"
                screenOptions={{
                  drawerType: isMobileOrTab ? 'front' : 'permanent',
                  drawerStyle: isMobileOrTab
                    ? AppStyles.mobileMenu
                    : AppStyles.menu,

                  headerShown: isMobileOrTab,
                  sceneContainerStyle: {
                    backgroundColor: CCColors.Background,
                  },
                  header: props => {
                    if (isMobileOrTab) {
                      return (
                        <Header
                          isMobile={isMobileOrTab}
                          userData={userData}
                          avatar={data.data.avatar}
                          navigationRef={navigationRef}
                          onLoginStateChange={onLoginStateChange}
                          summaryData={summaryData}
                          isEvaluateUser={isEvaluateUser}
                          showAppModal={showAppModal}
                          setShowAppModal={setShowAppModal}
                        />
                      );
                    }
                  },
                }}
                drawerContent={props => {
                  return (
                    <>
                      <MainMenu
                        isMobile={isMobileOrTab}
                        {...props}
                        userIsStaff={data.data.user.is_staff}
                        id={data.data?.assessment?.id}
                        openingGamePercentage={
                          data.data.assessment?.score?.opening
                        }
                        middleGamePercentage={
                          data.data.assessment?.score?.middlegame
                        }
                        endGamePercentage={data.data.assessment?.score?.endgame}
                        calculationDepthPercentage={
                          data.data.assessment?.score?.calculation_depth
                        }
                      />
                    </>
                  );
                }}>
                {filteredScreenStack
                  ?.filter(screen => screen.Name !== 'SquareTrainer')
                  .map(screen => {
                    const isChessAnalysisScreen = [
                      'chessAnalysis',
                      'leaderboard',
                      'RenewalPuzzleChallenge',
                      'positions',
                      'playChess',
                      'SaveOTBGames',
                      'resources',
                      'VisualisationTrainer',
                      'studyDetails',
                      'playChess',
                      'assessmentReport',
                      'Classroom',
                      'CCTournaments',
                      'FunChallengeBattle',
                      'PuzzleRoyaleBattle',
                      'ClubRoom',
                      'ClubProfile',
                    ]?.includes(screen.Name);
                    console.log(screen.Name, 'screen.Name');
                    const isSubscriptionOrCSOCTab =
                      screen.Name?.toLowerCase() === 'subscription' ||
                      screen.Name?.toLowerCase() === 'resources';

                    const Container = isChessAnalysisScreen ? View : ScrollView;
                    let formatedOptions =
                      isUserOnboarded(data) === 2
                        ? {
                            ...screen.menuOptions,
                            disabled: screen.menuOptions.preAnalysisDisabled,
                            unmountOnBlur: false,
                          }
                        : {...screen.menuOptions, disabled: false};
                    if (
                      isSubscriptionOrCSOCTab &&
                      data?.data?.user?.source?.toLowerCase() === 'chessklub'
                    ) {
                      setIsThirdPartyUser(true);
                      formatedOptions = {
                        // label: 'subscription',
                        hide: true,
                      };
                    }
                    if (
                      !data.data.user.is_staff &&
                      screen?.menuOptions?.isStaff
                    ) {
                      formatedOptions = {
                        // label: 'subscription',
                        hide: true,
                      };
                    }
                    return (
                      <Drawer.Screen
                        key={screen.id}
                        name={capitalizeFirstLetter(screen.Name)}
                        options={formatedOptions}>
                        {(props: any) => (
                          <RenderOnFocus>
                            <Container
                              showsVerticalScrollIndicator={false}
                              showsHorizontalScrollIndicator={false}
                              contentContainerStyle={{minHeight: '100%'}}
                              style={{
                                height: '100%',
                                overflowY: [
                                  'Inbox',
                                  'SupportTicket',
                                  'RequestAccess',
                                ].includes(screen.Name)
                                  ? 'hidden'
                                  : 'scroll',
                                overflowX: 'hidden',
                              }}>
                              <screen.component
                                {...props}
                                {...screen.props}
                                dashboardData={data.data}
                                data={data}
                                isUserLoggedIn={isUserLoggedIn}
                                isLoading={loading}
                                userData={userData}
                                setUserData={setUserData}
                                isBeginnerPlayer={isBeginnerPlayer}
                                setStreakCount={setStreakCount}
                                setStreakDetails={setStreakDetails}
                                changeClient={changeClient}
                                setChangeClient={setChangeClient}
                                modifyMainMenu={modifyMainMenu}
                                setModifyMainMenu={setModifyMainMenu}
                                authComplete={authComplete}
                              />
                            </Container>
                          </RenderOnFocus>
                        )}
                      </Drawer.Screen>
                    );
                  })}
              </Drawer.Navigator>
              <ChatbotWithNavigationControl navigationRef={navigationRef} />
              <ChallengeComponent username={username} />
              <FunChallengesGlobalListener />
            </ToastProvider>
          </SocketProvider>
        );
    }
  };

  return (
    <SafeAreaView style={{flex: 1}}>
      {!ENV.DEBUG_ENABLED && <SentryWrapper />}
      <NavigationContainer
        theme={{colors: {background: '#000'}}}
        ref={navigationRef}
        linking={linking}
        onReady={() => setIsNavigationReady(true)}
        documentTitle={{enabled: false}}>
        <PostMessageHandler
          onUserVerified={handleUserVerified}
          onVerificationError={handleVerificationError}
        />
        {userScreens()}

        {/* <ConditionalRender
          condition={!isUserLoggedIn && !isUserOnboarded(data) && showHome}
          childrenA={
            <Stack.Navigator screenOptions={{headerShown: false}}>
              <Stack.Screen name="home">
                {props => (
                  <CCHome
                    {...props}
                    onLoginStateChange={onLoginStateChange}
                    setShowHome={setShowHome}
                  />
                )}
              </Stack.Screen>
              <Stack.Screen name="Login">
                {props => (
                  <Login {...props} onLoginStateChange={onLoginStateChange} />
                )}
              </Stack.Screen>
            </Stack.Navigator>
          }
          childrenB={
            <>
              {!isUserLoggedIn && (
                <Stack.Navigator screenOptions={{headerShown: false}}>
                  <Stack.Screen name="Login">
                    {props => (
                      <Login
                        {...props}
                        onLoginStateChange={onLoginStateChange}
                      />
                    )}
                  </Stack.Screen>

                  <Stack.Screen name="Waitlist">
                    {props => <WaitList {...props} />}
                  </Stack.Screen>
                </Stack.Navigator>
              )}
              {isUserLoggedIn && isUserOnboarded(data) && isNewUser(data) ? (
                <Stack.Navigator screenOptions={{headerShown: false}}>
                  <Stack.Screen name="OnboardingWalkthrough">
                    {props => (
                      <OnboardingWalkthrough
                        {...props}
                        onLoginStateChange={onLoginStateChange}
                      />
                    )}
                  </Stack.Screen>
                </Stack.Navigator>
              ) : (
                <></>
              )}

              {isUserLoggedIn && !isUserOnboarded(data) && (
                <Stack.Navigator screenOptions={{headerShown: false}}>
                  {OnboardingScreenStack?.map(screen => (
                    <Stack.Screen
                      key={screen.id}
                      name={capitalizeFirstLetter(screen.Name)}>
                      {(props: any) => (
                        <Box style={{flex: 1}}>
                          <Box>
                            <screen.component
                              {...props}
                              onLoginStateChange={onLoginStateChange}
                              userData={data.data.user}
                            />
                          </Box>
                        </Box>
                      )}
                    </Stack.Screen>
                  ))}
                </Stack.Navigator>
              )}

              {isUserLoggedIn && isUserOnboarded(data) && !isNewUser(data) ? (
                <SocketProvider username={username} accessToken={accessToken}>
                  {!isMobileOrTab ? (
                    <Header
                      isMobile={isMobileOrTab}
                      userData={userData}
                      avatar={data.data.avatar}
                      navigationRef={navigationRef}
                      onLoginStateChange={onLoginStateChange}
                    />
                  ) : (
                    <></>
                  )}
                  <Drawer.Navigator
                    backBehavior="history"
                    screenOptions={{
                      drawerType: isMobileOrTab ? 'front' : 'permanent',
                      drawerStyle: isMobileOrTab
                        ? AppStyles.mobileMenu
                        : AppStyles.menu,

                      headerShown: isMobileOrTab,
                      sceneContainerStyle: {
                        backgroundColor: CCColors.Background,
                      },
                      header: props => {
                        if (isMobileOrTab) {
                          return (
                            <Header
                              isMobile={isMobileOrTab}
                              userData={userData}
                              avatar={data.data.avatar}
                              navigationRef={navigationRef}
                              onLoginStateChange={onLoginStateChange}
                            />
                          );
                        }
                      },
                    }}
                    drawerContent={props => (
                      <MainMenu
                        isMobile={isMobileOrTab}
                        {...props}
                        userIsStaff={data.data.user.is_staff}
                        id={data.data.assessment.id}
                        openingGamePercentage={
                          data.data.assessment.score?.opening
                        }
                        middleGamePercentage={
                          data.data.assessment.score?.middlegame
                        }
                        endGamePercentage={data.data.assessment.score?.endgame}
                        calculationDepthPercentage={
                          data.data.assessment.score?.calculation_depth
                        }
                      />
                    )}>
                    {ScreenStack?.map(screen => {
                      const isChessAnalysisScreen = [
                        'chessAnalysis',
                        'leaderboard',
                        'positions',
                        'playChess',
                        'SaveOTBGames',
                        'resources',
                        'VisualisationTrainer',
                        'studyDetails',
                        'playChess',
                        'assessmentReport',
                        'Renewal',
                        'FunChallengeBattle',
                        'PuzzleRoyaleBattle',
                        'ClubRoom',
                        'ClubProfile',
                      ]?.includes(screen.Name);
                      console.log(screen.Name, 'screen.Name');
                      const isSubscriptionOrCSOCTab =
                        screen.Name?.toLowerCase() === 'subscription' ||
                        screen.Name?.toLowerCase() === 'resources';

                      const Container = isChessAnalysisScreen
                        ? View
                        : ScrollView;
                      let formatedOptions =
                        isUserOnboarded(data) === 2
                          ? {
                              ...screen.menuOptions,
                              disabled: screen.menuOptions.preAnalysisDisabled,
                              unmountOnBlur: false,
                            }
                          : {...screen.menuOptions, disabled: false};
                      if (
                        isSubscriptionOrCSOCTab &&
                        data?.data?.user?.source?.toLowerCase() === 'chessklub'
                      ) {
                        setIsThirdPartyUser(true);
                        formatedOptions = {
                          // label: 'subscription',
                          hide: true,
                        };
                      }
                      if (
                        !data.data.user.is_staff &&
                        screen?.menuOptions?.isStaff
                      ) {
                        formatedOptions = {
                          // label: 'subscription',
                          hide: true,
                        };
                      }
                      return (
                        <Drawer.Screen
                          key={screen.id}
                          name={capitalizeFirstLetter(screen.Name)}
                          options={formatedOptions}>
                          {(props: any) => (
                            <RenderOnFocus>
                              <Container
                                showsVerticalScrollIndicator={false}
                                showsHorizontalScrollIndicator={false}
                                contentContainerStyle={{minHeight: '100%'}}
                                style={{
                                  height: '100%',
                                  overflowY: 'scroll',
                                  overflowX: 'hidden',
                                }}>
                                <screen.component
                                  {...props}
                                  {...screen.props}
                                  dashboardData={data.data}
                                  data={data}
                                  isUserLoggedIn={isUserLoggedIn}
                                  isLoading={loading}
                                  setUserData={setUserData}
                                />
                              </Container>
                            </RenderOnFocus>
                          )}
                        </Drawer.Screen>
                      );
                    })}
                  </Drawer.Navigator>
                  <CaissaChatbot />
                  <ChallengeComponent username={username} />
                  <FunChallengesGlobalListener />
                </SocketProvider>
              ) : (
                <></>
              )}
            </>
          }
        /> */}

        {/* <Stack.Navigator screenOptions={{headerShown: false}}>
          <Stack.Screen name="SignUp">
            {props => (
              <SignUp {...props} onLoginStateChange={onLoginStateChange} />
            )}
          </Stack.Screen>
        </Stack.Navigator> */}
        {/* {!isUserLoggedIn && (
          <Stack.Navigator screenOptions={{headerShown: false}}>
            <Stack.Screen name="Login">
              {props => (
                <Login {...props} onLoginStateChange={onLoginStateChange} />
              )}
            </Stack.Screen>

            <Stack.Screen name="Waitlist">
              {props => <WaitList {...props} />}
            </Stack.Screen>
          </Stack.Navigator>
        )}
        {isUserLoggedIn && isUserOnboarded(data) && isNewUser(data) && (
          <Stack.Navigator screenOptions={{headerShown: false}}>
            <Stack.Screen name="OnboardingWalkthrough">
              {props => (
                <OnboardingWalkthrough
                  {...props}
                  onLoginStateChange={onLoginStateChange}
                />
              )}
            </Stack.Screen>
          </Stack.Navigator>
        )}

        {isUserLoggedIn && !isUserOnboarded(data) && (
          <Stack.Navigator screenOptions={{headerShown: false}}>
            {OnboardingScreenStack?.map(screen => (
              <Stack.Screen
                key={screen.id}
                name={capitalizeFirstLetter(screen.Name)}>
                {(props: any) => (
                  <Box style={{flex: 1}}>
                    <Box>
                      <screen.component
                        {...props}
                        onLoginStateChange={onLoginStateChange}
                        userData={data.data.user}
                      />
                    </Box>
                  </Box>
                )}
              </Stack.Screen>
            ))}
          </Stack.Navigator>
        )}

        {isUserLoggedIn && isUserOnboarded(data) && !isNewUser(data) && (
          <>
            {!isMobileOrTab && (
              <Header
                isMobile={isMobileOrTab}
                userData={data.data.user}
                avatar={data.data.avatar}
                navigationRef={navigationRef}
                onLoginStateChange={onLoginStateChange}
              />
            )}
            <Drawer.Navigator
              screenOptions={{
                drawerType: isMobileOrTab ? 'front' : 'permanent',
                drawerStyle: isMobileOrTab
                  ? AppStyles.mobileMenu
                  : AppStyles.menu,

                headerShown: isMobileOrTab,
                sceneContainerStyle: {
                  backgroundColor: CCColors.Background,
                },
                header: props => {
                  if (isMobileOrTab) {
                    return (
                      <Header
                        isMobile={isMobileOrTab}
                        userData={data.data.user}
                        avatar={data.data.avatar}
                        navigationRef={navigationRef}
                        onLoginStateChange={onLoginStateChange}
                      />
                    );
                  }
                },
              }}
              drawerContent={props => (
                <MainMenu isMobile={isMobileOrTab} {...props} />
              )}>
              {ScreenStack?.map(screen => {
                const isChessAnalysisScreen = [
                  'chessAnalysis',
                  'leaderboard',
                  'positions',
                  'playChess',
                  'SaveOTBGames',
                  'resources',
                  'VisualisationTrainer',
                  'studyDetails',
                  'playChess',
                  'assessmentReport',
                  'FunChallengeBattle',
                  'PuzzleRoyaleBattle',
                  'ClubRoom',
                  'ClubProfile',
                ]?.includes(screen.Name);

                const Container = isChessAnalysisScreen ? View : ScrollView;

                const formatedOptions =
                  isUserOnboarded(data) === 2
                    ? {
                        ...screen.menuOptions,
                        disabled: screen.menuOptions.preAnalysisDisabled,
                      }
                    : {...screen.menuOptions, disabled: false};
                return (
                  <Drawer.Screen
                    key={screen.id}
                    name={capitalizeFirstLetter(screen.Name)}
                    options={formatedOptions}>
                    {(props: any) => (
                      <RenderOnFocus>
                        <Container
                          showsVerticalScrollIndicator={false}
                          style={{height: '100%'}}>
                          <screen.component
                            {...props}
                            {...screen.props}
                            dashboardData={data.data}
                          />
                        </Container>
                      </RenderOnFocus>
                    )}
                  </Drawer.Screen>
                );
              })}
            </Drawer.Navigator>
          </>
        )} */}
        {showAppModal && (
          <SwitchToAppModal
            setShowAppModalHome={setShowAppModal}
            isMobileOrTab={isMobileOrTab}
          />
        )}
        <SubscriptionModal user={data?.data?.user} />

        {showPincodeModal &&
          navigationRef?.getCurrentRoute()?.name === 'Dashboard' && (
            <PincodeModal
              pincode={pincode}
              setPincode={setPincode}
              setShowPincodeModal={setShowPincodeModal}
              setModalDismissed={setModalDismissed}
              mobileNumber={data?.data?.user?.mobile_number}
            />
          )}

        <AlertModal />
      </NavigationContainer>
    </SafeAreaView>
  );
};

function RenderOnFocus({children}) {
  const isFocused = useIsFocused();

  if (isFocused) {
    return (
      <TouchableWithoutFeedback
        onPress={() => {
          useLoggedInUserStore.setState({
            dropDownClose: true,
          });
        }}>
        {children}
      </TouchableWithoutFeedback>
    );
  } else {
    return <></>;
  }
}

export default ApplicationNavigator;
